<template>
  <div class="need-help-container">
    <div class="need-help-grid">
      <a href="/faq" target="_blank" alt="FAQ" class="need-help-cell" aria-label="F A Q (opens in new tab)">
        <span class="af af-faq need-help-icon"></span>
        <span class="need-help-icon-caption">FAQ</span>
      </a>
      <a
        :href="'tel:' + phoneNumber.split('.').join('-')"
        :alt="'Call ' + phoneNumber"
        class="need-help-cell"
        :aria-label="'Call our Customer Care team at ' + phoneNumber.split('.').join('-')"
      >
        <span class="af af-call need-help-icon"></span>
        <span class="need-help-icon-caption need-help-caption-call-number" v-text="'+' + phoneNumber"></span>
        <span class="need-help-icon-caption need-help-caption-call-callword">CALL</span>
      </a>
      <a alt="Start Chat" class="need-help-cell livechat-link" @click="chat" aria-label="Chat" tabindex="0">
        <span class="af af-chat need-help-icon"></span>
        <span class="need-help-icon-caption">CHAT</span>
      </a>
      <a href="/contact/message" target="_blank" class="need-help-cell" aria-label="Email (opens in a new tab)">
        <span class="af af-mail need-help-icon"></span>
        <span class="need-help-icon-caption">EMAIL</span>
      </a>
    </div>
  </div>
</template>

<script>
import useCommon from '@/compositions/useCommon';

import UserService from '@/services/UserService';

export default {
  name: 'NeedHelp',
  data() {
    return {
      phoneNumber: '1.888.746.3455',
      email: 'service@article.com',
    };
  },
  beforeMount() {
    if (UserService.isTrade()) {
      this.phoneNumber = '1.888.484.5121';
      this.email = 'trade@article.com';
    }
  },

  setup() {
    const { chat } = useCommon();

    return {
      chat,
    };
  },
};
</script>

<style lang="postcss">
@import '@/pixel/style/variables';

.need-help-container {
  background-color: var(--background-color);
  font-size: 1.2em;

  .need-help-grid {
    max-width: 600px;
    height: 60px;
    margin: auto;
    padding: 32px 24px;
    display: flex;
    justify-content: space-between;

    .need-help-cell {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      span {
        padding: 2px 0;

        &.af {
          font-size: 1.5em;
        }
      }

      .need-help-caption-call-callword {
        display: none;
      }

      @media (max-width: calc($mobile-breakpoint - 1px)) {
        .need-help-caption-call-number {
          display: none;
        }
        .need-help-caption-call-callword {
          display: block;
        }
      }
    }
  }
}
</style>
